import { UserDataSourceService } from './../../../core/data-sources/user-data-source.service';
import { ActionPermissionsService } from './../../../core/services/action-permissions.service';
import { CrateStateEnum, CrateType } from './../../../../models/Crate';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { toExcelFormat } from '../../../helpers/format-position';
import { findCrateLevel } from '../../../helpers/find-crate-level';
import { translateState } from 'src/models/Crate';
import { getCrateTypeName } from 'src/app/helpers/format-crate-type';
import { formatGroundPositionName } from 'src/app/helpers/get-ground-positions';
import { UserRoles } from '../../../../models/User';
import { ActivatedRoute } from '@angular/router';
import { ActionsEnum, SendTasksTypeEnum } from '../../../core/data-sources/action-data-source.service';
import { TenantService } from 'src/app/core/services/tenant.service';
import { TenantInterface } from 'src/models/Tenant';
import formatDate from 'src/app/helpers/format-date';
import { UserModel } from 'src/app/core/data-sources/user-data-source.service';

export interface CrateItem {
  name: string;
  packSize: number;
  quantity: number;
  sku: string;
  productName?: string;
}

@Component({
  selector: 'app-pallet-details',
  templateUrl: './pallet-details.component.html',
  styleUrls: ['./pallet-details.component.scss']
})
export class PalletDetailsComponent implements OnInit, OnChanges {
  @Input() isMap = false; // input to control which is the parent component
  @Input() crateDetails;
  @Input() isExit = false;
  @Input() fromPendingTask = false;
  @Output() relocateClicked = new EventEmitter();
  @Output() inventoryClicked = new EventEmitter();
  @Output() blockClicked = new EventEmitter();
  @Output() unblockClicked = new EventEmitter();
  @Output() setUnderAlert = new EventEmitter<string>();
  @Output() unsetUnderAlert = new EventEmitter<string>();
  translateState = translateState;
  skuGroups: CrateItem[] = [];
  CrateTypeEnum = CrateType;
  excelPosition;
  level;
  displayedColumns: string[] = ['name', 'packSize', 'quantity', 'sku'];
  showProductImage = false;
  currentProductImageUrl = '';
  displayMode: 'table' | 'list' = 'list';
  userRole: UserRoles = null;
  sendTaskTypesEnum = SendTasksTypeEnum;
  tenant: TenantInterface;
  userThatBlockedPallet: UserModel = null;

  constructor(
    private route: ActivatedRoute,
    private actionPermissionsService: ActionPermissionsService,
    private tenantService: TenantService,
    private userDataSourceService: UserDataSourceService
  ) { }

  async ngOnInit() {
    this.userRole = this.route.firstChild.snapshot.data.role;
    this.skuGroups = this.crateDetails.crate.skuGroups;
    this.excelPosition = toExcelFormat(this.crateDetails.crate.x, this.crateDetails.crate.y);
    this.level = findCrateLevel(this.crateDetails.crate.z, this.crateDetails.levels);
    this.tenant = await this.tenantService.get();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.crateDetails) {
      this.getUserThatBlockedPallet();
    }
  }

  canClickButton(action: ActionsEnum | SendTasksTypeEnum, role: UserRoles) {
    return this.actionPermissionsService.hasPermission(action, role);
  }

  cantRelocate(action: ActionsEnum | SendTasksTypeEnum, role: UserRoles) { //TODO: alterar para canRelocate
    if (!this.tenant?.features.relocation) {
      return true;
    }
    const { state } = this.crateDetails.crate;
    const invalidStates = ['WRONG_POSITION', 'STORED', 'MISPLACED_DIVERGENT', 'MISPLACED'];
    return !invalidStates.includes(state) || this.crateDetails.position.type === 'PICKING' || !this.canClickButton(action, role);
  }

  relocateClick() {
    if (this.isMap) {
      this.relocateClicked.emit({
        crate: this.crateDetails.crate
      });
      return
    }
    this.relocateClicked.emit();
  }

  getCrateType(type: CrateType) {
    return getCrateTypeName(type);
  }

  getPosition(position) {
    return formatGroundPositionName(position, 'alias');
  }

  openInventorySidenav(crate) {
    crate.level = this.level;
    this.inventoryClicked.emit(crate);
  }

  productClicked(event: {product: CrateItem, url: string}) {
    this.currentProductImageUrl = event.url;
    if (this.currentProductImageUrl) {
      this.showProductImage = true;
    }

  }
  displayClicked() {
    this.showProductImage = false;
    this.currentProductImageUrl = '';
  }
  onDisplayModeChange(mode: 'table' | 'list') {
    this.displayMode = mode;
  }

  setPalletUnderAlert(crateId: string) {
    this.setUnderAlert.emit(crateId);
  }

  unsetPalletUnderAlert(crateId: string) {
    this.unsetUnderAlert.emit(crateId);
  }

  canBlockPallet() {
    return this.actionPermissionsService.hasPermission(ActionsEnum.SET_PALLET_UNDER_ALERT, this.userRole) && this.crateDetails?.crate?.type !== this.CrateTypeEnum.REMAINS;
  }

  canUnblockPallet() {
    return this.actionPermissionsService.hasPermission(ActionsEnum.UNSET_PALLET_UNDER_ALERT, this.userRole);
  }

  formatTimestamp(timestamp: number) {
    return formatDate(timestamp);
  }

  getUserThatBlockedPallet() {
    const userId = this.crateDetails.crate?.cratesUnderAlert?.[0]?.userId;
    if (userId) {
      this.userDataSourceService.v3GetUserById(userId).then(res => {
        this.userThatBlockedPallet = res.values[0];
      });
    }
  }

  checkIfPalletIsInSeparation(): boolean {
    const state = this.crateDetails?.crate?.state;

    const separationStates = [
      CrateStateEnum.AWAITING_EXPEDITION,
      CrateStateEnum.RESERVED,
      CrateStateEnum.AWAITING_PICKING,
      CrateStateEnum.READY_TO_DISPATCH,
      CrateStateEnum.MISPLACED_EXPEDITION
    ];
    return separationStates.includes(state);
  }
}